import { render, staticRenderFns } from "./TabShortVideo.vue?vue&type=template&id=2ca7538e&scoped=true&"
import script from "./TabShortVideo.vue?vue&type=script&lang=ts&"
export * from "./TabShortVideo.vue?vue&type=script&lang=ts&"
import style0 from "./TabShortVideo.vue?vue&type=style&index=0&id=2ca7538e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7538e",
  null
  
)

export default component.exports